import BenefitsOfKeyzyNow from "./BenefitsOfKeyzyNow";

export default BenefitsOfKeyzyNow;
